import React from "react";
import { CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { IconClock } from "@tabler/icons-react";

interface RefereeNameCellProps {
  refereeName?: string | null;
  refereeEmail?: string | null;
}

/**
 * Component for displaying referee name/email with copy functionality
 */
export const RefereeNameCell: React.FC<RefereeNameCellProps> = ({
  refereeName,
  refereeEmail,
}) => {
  const hasEmail =
    refereeEmail && refereeEmail.trim() !== "" && refereeEmail !== "Pending";

  const hasName = refereeName && refereeName.trim() !== "";

  if (hasName) {
    return (
      <CopyButton value={refereeEmail || ""}>
        {({ copied, copy }) => (
          <Tooltip
            label={copied ? "Copied!" : "Click to copy"}
            disabled={!hasEmail}
          >
            <Text
              size="sm"
              fw={500}
              c="dark"
              style={{
                cursor: hasEmail ? "pointer" : "default",
              }}
              onClick={(e) => {
                if (hasEmail) {
                  e.stopPropagation();
                  copy();
                }
              }}
            >
              {refereeName}
            </Text>
          </Tooltip>
        )}
      </CopyButton>
    );
  }

  if (hasEmail) {
    return (
      <CopyButton value={refereeEmail || ""}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? "Copied!" : "Click to copy"}>
            <Text
              size="sm"
              fw={500}
              c="dark"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                copy();
              }}
            >
              {refereeEmail}
            </Text>
          </Tooltip>
        )}
      </CopyButton>
    );
  }

  return (
    <Group gap={8}>
      <IconClock size={16} color="gray" />
      <Text size="sm" c="dimmed" fs="italic">
        Pending
      </Text>
    </Group>
  );
};
